module.exports = __webpack_public_path__ + "img/ant-design.2eb602d4.svg";